import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAssetAttachments } from '../../../Slices/assetSlice';
import { S3ACCESSURL } from '../../../databucket';

const Tool = () => {
    const dispatch = useDispatch();
    const assetAttachments = useSelector((state) => state.Assets.assetAttachments);
    const [groupedAttachments, setGroupedAttachments] = useState({});

    useEffect(() => {
        dispatch(getAllAssetAttachments());
    }, [dispatch]);

    useEffect(() => {
        if (assetAttachments?.length > 0) {
            const grouped = {};
            assetAttachments.forEach(item => {
                const validAttachments = item.attachments?.filter(att => att.status === true);
                if (validAttachments?.length > 0) {
                    grouped[item.assetTagId] = validAttachments;
                }
            });
            setGroupedAttachments(grouped);
        }
    }, [assetAttachments]);


    const getFileName = (file) => {
        if (file?.name) return file.name;
        if (file?.filename) return file.filename;
        try {
            const parts = file.data.split('/');
            return decodeURIComponent(parts[parts.length - 1].split('?')[0]);
        } catch {
            return 'Unknown File';
        }
    };
    const [hoveredPreview, setHoveredPreview] = useState(null);

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h2>Assets Attachments</h2>
                </div>

                <div className="row mt-4">
                    {Object.entries(groupedAttachments).map(([assetTagId, attachments], i) => (
                        <div className="col-3 mb-4 d-flex align-items-stretch" key={i}>
                            <div
                                style={{
                                    width: '100%',
                                    minHeight: '120px',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '12px',
                                    padding: '15px',
                                    backgroundColor: '#fff',
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 6px 16px rgba(0,0,0,0.12)';
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.06)';
                                    e.currentTarget.style.transform = 'translateY(0)';
                                }}
                            >
                                <div style={{ marginBottom: '10px', fontWeight: 'bold', color: '#333' }}>
                                    Asset Tag ID: {assetTagId}
                                </div>

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                                    {attachments?.filter(file => file.status === true).map((file, index) => {
                                        const isImage = file.mimetype?.includes('image');
                                        const isCSV = file.mimetype?.includes('csv') || file.filename?.toLowerCase().endsWith('.csv');
                                        const isPDF = file.mimetype?.includes('pdf') || file.filename?.toLowerCase().endsWith('.pdf');

                                        return (
                                            <div
                                                key={index}
                                                style={{
                                                    width: '100px',
                                                    height: '100px',
                                                    borderRadius: '6px',
                                                    cursor: 'pointer',
                                                    overflow: 'hidden',
                                                    position: 'relative',
                                                    backgroundColor: !isImage ? '#f0f0f0' : 'transparent',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    textAlign: 'center',
                                                    padding: !isImage ? '5px' : 0,
                                                    fontSize: !isImage ? '12px' : undefined,
                                                    color: !isImage ? '#555' : undefined,
                                                }}
                                                onMouseEnter={async () => {
                                                    if (isImage) {
                                                        setHoveredPreview({ type: 'image', data: file.data });
                                                    }
                                                }}
                                                onMouseLeave={() => {
                                                    if (isImage) setHoveredPreview(null);
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    const fullUrl = `${S3ACCESSURL}${file.data}`;
                                                    window.open(fullUrl, '_blank');
                                                }}

                                            >
                                                {isImage ? (
                                                    <img
                                                        src={`${S3ACCESSURL}${file.url || file.data}`}
                                                        alt="/pdfimg.avif"
                                                        title={file.filename}
                                                        style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            objectFit: 'cover',
                                                            borderRadius: '6px',
                                                        }}
                                                    />
                                                ) : isPDF ? (
                                                    <img
                                                        src="/pdfimg.avif"
                                                        alt={file.filename}
                                                        title={file.filename}
                                                        style={{
                                                            width: '60%',
                                                            height: '60%',
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                ) : isCSV ? (
                                                    <img
                                                        src="/csvimage.png"
                                                        alt={file.filename}
                                                        title={file.filename}
                                                        style={{
                                                            width: '60%',
                                                            height: '60%',
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                ) : (
                                                    <span>{file.filename || 'File'}</span>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Image preview on hover */}
            {hoveredPreview?.type === 'image' && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                        padding: '40px',
                        pointerEvents: 'none',
                    }}
                >
                    <img
                        src={`${S3ACCESSURL}${hoveredPreview.data}`}
                        alt="Preview"
                        style={{
                            maxWidth: '90vw',
                            maxHeight: '90vh',
                            objectFit: 'contain',
                            borderRadius: '10px',
                            boxShadow: '0 0 20px rgba(255, 255, 255, 0.2)',
                        }}
                    />
                </div>
            )}
        </div>
    );

};

export default Tool;
